import { render, staticRenderFns } from "./EditTask.vue?vue&type=template&id=efeb177a&scoped=true&"
import script from "./EditTask.vue?vue&type=script&lang=js&"
export * from "./EditTask.vue?vue&type=script&lang=js&"
import style0 from "./EditTask.vue?vue&type=style&index=0&id=efeb177a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efeb177a",
  null
  
)

export default component.exports